import { Button, Form, Card, Alert } from 'react-bootstrap';
import React, { useState } from 'react';
import '../App.css';

export const ResetPasswordPage = () => {
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: '',
    });
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Get token from URL query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        // Clear messages when user types
        setErrorMessage('');
        setSuccessMessage('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous messages
        setErrorMessage('');
        setSuccessMessage('');

        // Validate passwords match
        if (formData.newPassword !== formData.confirmPassword) {
            setErrorMessage('Şifreler eşleşmiyor.');
            return;
        }

        // Validate password length
        if (formData.newPassword.length < 6) {
            setErrorMessage('Şifre en az 6 karakter olmalıdır.');
            return;
        }

        // Validate token exists
        if (!token) {
            setErrorMessage('Geçersiz şifre sıfırlama linki.');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch('https://nuremberg.kentistturizm.com/api/resetPasswordWithToken', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token,
                    newPassword: formData.newPassword,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccessMessage(data.message || 'Şifreniz başarıyla değiştirildi. Giriş yapabilirsiniz.');
                setFormData({ newPassword: '', confirmPassword: '' });

                // Optionally redirect to login after 2 seconds
                // setTimeout(() => {
                //     window.location.href = '/';
                // }, 2000);
            } else {
                setErrorMessage(data.error || 'Şifre sıfırlanırken hata oluştu.');
            }
        } catch (error) {
            setErrorMessage('Şifre sıfırlanırken hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container" style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            width: '100%',
            overflow: 'hidden',
            gap: '30px',
            padding: '20px'
        }}>
            <div className="text-center" style={{
                background: 'white',
                padding: '8px 20px',
                borderRadius: '30px',
                display: 'inline-flex',
                alignItems: 'center'
            }}>
                <img
                    src={`${process.env.PUBLIC_URL}/kentistlogo.png`}
                    alt="Kentist Turizm"
                    style={{ width: '250px' }}
                />
            </div>

            <Card style={{
                borderRadius: '20px',
                width: '100%',
                maxWidth: '500px',
                minHeight: '400px',
                boxShadow: '0 8px 40px 0 rgba(20, 52, 92, 0.4), 0 0 0 1px rgba(20, 52, 92, 0.3)',
                display: 'flex',
                background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(40, 40, 40, 0.95) 100%)',
                backdropFilter: 'blur(20px)',
                border: '2px solid rgba(20, 52, 92, 0.5)',
                padding: '20px 40px 40px 40px'
            }}>
                <Card.Body style={{ padding: 0 }}>
                    <h2 className="text-center my-4" style={{
                        color: '#5a9bd4',
                        textShadow: '0 0 20px rgba(20, 52, 92, 0.6)',
                        fontWeight: '700',
                        letterSpacing: '1px',
                        marginBottom: '10px'
                    }}>
                        Kentist Uygulama<br />Şifre Sıfırlama
                    </h2>
                    <p className="text-center" style={{
                        color: '#5a9bd4',
                        fontSize: '0.85rem',
                        marginBottom: '30px',
                        opacity: 0.8
                    }}>
                        (Kentist Yolcu & Yönetici)
                    </p>

                    {successMessage && (
                        <Alert variant="success" dismissible onClose={() => setSuccessMessage('')}>
                            {successMessage}
                        </Alert>
                    )}

                    {errorMessage && (
                        <Alert variant="danger" dismissible onClose={() => setErrorMessage('')}>
                            {errorMessage}
                        </Alert>
                    )}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="newPassword">
                            <Form.Label style={{ color: '#5a9bd4', fontWeight: '500' }}>
                                Yeni Şifre:
                            </Form.Label>
                            <Form.Control
                                type="password"
                                name="newPassword"
                                value={formData.newPassword}
                                onChange={handleInputChange}
                                required
                                minLength={6}
                                placeholder="En az 6 karakter"
                                style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(20, 52, 92, 0.5)',
                                    color: 'white'
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="confirmPassword" style={{ marginTop: 20 }}>
                            <Form.Label style={{ color: '#5a9bd4', fontWeight: '500' }}>
                                Yeni Şifre (Tekrar):
                            </Form.Label>
                            <Form.Control
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                required
                                minLength={6}
                                placeholder="Şifrenizi tekrar girin"
                                style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(20, 52, 92, 0.5)',
                                    color: 'white'
                                }}
                            />
                        </Form.Group>

                        <Button
                            style={{
                                width: '100%',
                                marginTop: 30,
                                background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)',
                                border: 'none',
                                color: '#fff',
                                fontWeight: '700',
                                padding: '12px 30px',
                                boxShadow: '0 4px 15px rgba(20, 52, 92, 0.5)',
                                transition: 'all 0.3s ease'
                            }}
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? 'Şifre Sıfırlanıyor...' : 'Şifreyi Sıfırla'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>

            <div className="text-center" style={{ marginTop: '20px' }}>
                <img
                    src={`${process.env.PUBLIC_URL}/tulparfooterinverted.png`}
                    alt="Tulpar"
                    style={{
                        maxWidth: '150px',
                        width: '100%',
                        opacity: 0.7,
                        filter: 'drop-shadow(0 0 10px rgba(20, 52, 92, 0.3))'
                    }}
                />
            </div>
        </div>
    );
};
